/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   proConData meta reducer
 */

import {
  falseReducer,
  nullReducer,
  payloadKeyReducer,
  payloadReducer,
  trueReducer,
} from '@zcode/reducers'
import type { ProConDataMetaType } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CLEAR_PRO_CON_DATA,
  DONE_FETCHING_PRO_CON_DATA,
  ERROR_FETCHING_PRO_CON_DATA,
  START_FETCHING_PRO_CON_DATA,
} from '../constants/index'
import type { ActionTypes } from './types'

export const metaReducer = combineReducers<ProConDataMetaType, ActionTypes>({
  error: handleActions<ProConDataMetaType['error'], ActionTypes>(
    {
      [ERROR_FETCHING_PRO_CON_DATA]: payloadReducer,
      [CLEAR_PRO_CON_DATA]: nullReducer,
      [START_FETCHING_PRO_CON_DATA]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_PRO_CON_DATA]: trueReducer,
      [CLEAR_PRO_CON_DATA]: falseReducer,
      [DONE_FETCHING_PRO_CON_DATA]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<ProConDataMetaType['fetchingKey'], ActionTypes>(
    {
      [START_FETCHING_PRO_CON_DATA]: payloadKeyReducer('key'),
      [CLEAR_PRO_CON_DATA]: nullReducer,
      [DONE_FETCHING_PRO_CON_DATA]: nullReducer,
    },
    null
  ),
  currentKey: handleActions<ProConDataMetaType['currentKey'], ActionTypes>(
    {
      [CLEAR_PRO_CON_DATA]: nullReducer,
      [DONE_FETCHING_PRO_CON_DATA]: (state, { payload }) => payload?.key ?? state,
    },
    null
  ),
})
